import React from 'react';

interface TextProps {
    className: string, 
    style: object, 
    word: string, 
    fontSize: number, 
    children: React.ReactChildren,
    draggable: boolean,
    onDragStart: Function
}

export default function Text(textProps:TextProps) {

    const {className, style = {}, fontSize, children, draggable = false, onDragStart} = textProps;

    let props: any = {
        draggable,
        style: {
            ...style,
            fontSize: fontSize + "px"
        }
    }
    if (className) props.className = className;
    if (onDragStart) props.onDragStart = onDragStart;
    if (fontSize < 12) props.style.transform = `scale(${fontSize / 12})`

    return (
    <p {...props}>{children}</p>
    )
}